import { JsonSchemaFormController } from './schema_form_generator.directive.controller';

export class JsonSchemaForm {
  public restrict: string;
  public templateUrl: string;
  public controller: any;
  public scope: any;
  public controllerAs: string;
  public bindToController: boolean;
  public transclude: any;

  constructor() {
    this.restrict = 'EA';
    this.templateUrl = 'app/angularJS/components/json_schema_form/schema_form_generator/schema_form_generator.html';
    this.scope = {
      ok: '=',
      fetchSchemaTypes: '=',
      model: '=',
      cancel: '=',
      currentSchemaId: '=',
      form: '=',
      primaryButtonText: '@',
      schemaServiceName: '@'
    };
    this.controller = JsonSchemaFormController;
    this.controllerAs = 'vm';
    this.bindToController = true;
  }
}